import { render, staticRenderFns } from "./SectionMedjugorje.vue?vue&type=template&id=02e57967&scoped=true"
import script from "./SectionMedjugorje.vue?vue&type=script&lang=js"
export * from "./SectionMedjugorje.vue?vue&type=script&lang=js"
import style0 from "./SectionMedjugorje.vue?vue&type=style&index=0&id=02e57967&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e57967",
  null
  
)

export default component.exports